// extracted by mini-css-extract-plugin
export default {"rating":"IL-z","numberOfStars":"JL-z","count":"KL-z","barGraphSpacing":"LL-z","barGraph":"ML-z"};